export default __webpack_public_path__ + "2286c7fd5e94bd7ef1b237be2e941b4f.svg";